// React Context for content management
import { createContext, useContext, ReactNode, useState, useEffect } from 'react'
import { loadAllContent, ContentData } from './content'
import { useTranslation } from '@/i18n'

// Create context with proper typing
const ContentContext = createContext<ContentData | null>(null)

// Provider component
export function ContentProvider({ children }: { children: ReactNode }) {
  const { locale } = useTranslation()
  const [content, setContent] = useState<ContentData>(() => loadAllContent(locale))

  // Reload content when language changes
  useEffect(() => {
    setContent(loadAllContent(locale))
  }, [locale])

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
}

// Custom hook to use content
// eslint-disable-next-line react-refresh/only-export-components
export function useContent() {
  const context = useContext(ContentContext)
  if (!context) {
    throw new Error('useContent must be used within ContentProvider')
  }
  return context
}
